const selectors = {
  container: '[data-products-container]',
  grid: '[data-products-grid]',
  button: '[data-load-more]',
  sentinel: '[data-load-more-sentinel]',
};

const parser = new DOMParser();
let observer;
let isLoading = false;

const buildSectionUrl = (url, sectionId) => {
  const parsedUrl = new URL(url, window.location.origin);
  parsedUrl.searchParams.set('sections', sectionId);
  return parsedUrl.toString();
};

const parseHtml = (html) => parser.parseFromString(html, 'text/html');

const appendProducts = (sourceDoc, container) => {
  const newContainer = sourceDoc.querySelector(selectors.container);
  const targetGrid = container.querySelector(selectors.grid);
  const newGrid = newContainer?.querySelector(selectors.grid);

  if (!newGrid || !targetGrid) return;

  const newItems = Array.from(newGrid.children);
  targetGrid.append(...newItems);
  if (newItems.length) {
    document.dispatchEvent(new CustomEvent('collection:products-appended', { detail: { count: newItems.length } }));
  }
};

const updateButtonState = (sourceDoc, button, sentinel) => {
  const nextButton = sourceDoc.querySelector(selectors.button);

  if (nextButton && nextButton.dataset.nextUrl) {
    button.dataset.nextUrl = nextButton.dataset.nextUrl;
    button.disabled = false;
    button.textContent = 'Carica altri';
    if (sentinel && observer) {
      observer.observe(sentinel);
    }
  } else {
    if (observer && sentinel) {
      observer.unobserve(sentinel);
    }
    button.remove();
    sentinel?.remove();
  }
};

const handleLoadMore = async (button) => {
  if (isLoading) return;

  const container = document.querySelector(selectors.container);
  const sectionId = container?.dataset.sectionId;
  const nextUrl = button?.dataset.nextUrl;
  const sentinel = document.querySelector(selectors.sentinel);

  if (!container || !sectionId || !nextUrl) return;

  isLoading = true;
  button.disabled = true;
  button.textContent = 'Caricamento…';
  if (observer && sentinel) {
    observer.unobserve(sentinel);
  }

  try {
    const response = await fetch(buildSectionUrl(nextUrl, sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!response.ok) {
      throw new Error(`Errore di caricamento: ${response.status}`);
    }

    const data = await response.json();
    const html = data[sectionId];

    if (!html) throw new Error('Risposta sezione non valida');

    const doc = parseHtml(html);
    appendProducts(doc, container);
    updateButtonState(doc, button, sentinel);
  } catch (error) {
    console.error(error);
    button.disabled = false;
    button.textContent = 'Riprova';
  } finally {
    isLoading = false;
  }
};

const attachObserver = (button) => {
  const sentinel = document.querySelector(selectors.sentinel);
  if (!('IntersectionObserver' in window) || !sentinel) return;

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !button.disabled && button.dataset.nextUrl) {
        handleLoadMore(button);
      }
    });
  }, { rootMargin: '300px 0px' });

  observer.observe(sentinel);
};

const initLoadMore = () => {
  const button = document.querySelector(selectors.button);
  if (!button) return;

  button.addEventListener('click', () => handleLoadMore(button));
  attachObserver(button);
};

document.addEventListener('DOMContentLoaded', initLoadMore);

